"use client";

import { useEffect } from "react";
import { initCapacitor } from "@/lib/capacitor/init";

export function CapacitorBoot() {
  useEffect(() => {
    initCapacitor();
  }, []);
  return null;
}
